<div (mousedown)="onBackdropMouseDown($event)" class="app-modal-backdrop">
    <section [style.width]="width" aria-modal="true" class="app-modal-panel" role="dialog">
        <ng-content></ng-content>
    </section>
</div>
